// extracted by mini-css-extract-plugin
export var formContainer = "_h7-0";
export var message = "_h7-1";